<template>
  <div class="currency-input-wrapper">
    <span class="currency-prefix">$</span>
    <input
      type="text"
      :value="formattedValue"
      @input="handleInput"
      @blur="handleBlur"
      @focus="handleFocus"
      class="currency-input"
      :placeholder="placeholder"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
  name: 'CurrencyInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: '0'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  
  setup(props, { emit }) {
    const isFocused = ref(false);
    const rawValue = ref(props.modelValue);
    
    // Watch for external changes
    watch(() => props.modelValue, (newVal) => {
      rawValue.value = newVal;
    });
    
    const formattedValue = computed(() => {
      if (isFocused.value) {
        // When focused, show raw number for easy editing
        return rawValue.value ? String(rawValue.value) : '';
      }
      // When not focused, show formatted with commas
      const num = Number(rawValue.value) || 0;
      return num.toLocaleString('en-US');
    });
    
    const handleInput = (event) => {
      // Remove non-numeric characters except for the value
      const value = event.target.value.replace(/[^0-9]/g, '');
      const numValue = parseInt(value, 10) || 0;
      rawValue.value = numValue;
      emit('update:modelValue', numValue);
    };
    
    const handleFocus = () => {
      isFocused.value = true;
    };
    
    const handleBlur = () => {
      isFocused.value = false;
    };
    
    return {
      formattedValue,
      handleInput,
      handleFocus,
      handleBlur
    };
  }
};
</script>

<style scoped>
.currency-input-wrapper {
  display: flex;
  align-items: center;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  transition: all 0.2s ease;
}

.currency-input-wrapper:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.currency-prefix {
  color: #718096;
  font-weight: 600;
  margin-right: 0.25rem;
}

.currency-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  width: 100%;
  text-align: right;
}

.currency-input:disabled {
  color: #a0aec0;
  cursor: not-allowed;
}

.currency-input::placeholder {
  color: #cbd5e0;
}
</style>

